import type { ReactNode } from "react";
import { Outlet } from "react-router-dom";
import { PublicHeader } from "./PublicHeader";
import { PublicFooter } from "./PublicFooter";
import { Breadcrumbs } from "./Breadcrumbs";

interface PublicLayoutProps {
    children?: ReactNode;
}

export function PublicLayout({ children }: PublicLayoutProps) {
    return (
        <div className="min-h-screen flex flex-col font-sans selection:bg-blue-100 selection:text-blue-900 bg-white">
            <PublicHeader />
            <main className="flex-1 pt-16">
                <Breadcrumbs />
                {children || <Outlet />}
            </main>
            <PublicFooter />
        </div>
    );
}
